import type {
  LegacyHistoricalReportAsset,
  LegacyHistoricalReportBaseline,
  LegacyHistoricalReportResolvedAsset,
} from "../types/legacyHistoricalReport";

export function resolveHistoricalReportAsset(
  asset: LegacyHistoricalReportAsset,
  resolved: LegacyHistoricalReportResolvedAsset[] = []
): string | undefined {
  const match = resolved.find(
    (candidate) =>
      candidate.id === asset.id &&
      candidate.sha256 === asset.sha256 &&
      candidate.mimeType === asset.mimeType
  );
  if (!match || !/^[a-f\d]{64}$/i.test(asset.sha256)) return undefined;
  if (
    !Number.isFinite(asset.width) ||
    !Number.isFinite(asset.height) ||
    asset.width <= 0 ||
    asset.height <= 0
  )
    return undefined;
  const prefix = `data:${asset.mimeType};base64,`;
  return match.dataUri.startsWith(prefix) &&
    /^[A-Za-z\d+/]+={0,2}$/.test(match.dataUri.slice(prefix.length))
    ? match.dataUri
    : undefined;
}

export function hasUnavailableHistoricalAssets(
  baseline: LegacyHistoricalReportBaseline,
  resolved: LegacyHistoricalReportResolvedAsset[] = []
): boolean {
  const assets = [
    ...baseline.organMaps,
    ...baseline.signatures.flatMap((signature) =>
      signature.asset ? [signature.asset] : []
    ),
  ];
  return assets.some((asset) => !resolveHistoricalReportAsset(asset, resolved));
}
